// Chargez le script Google Maps lorsque la page est entièrement chargée
document.addEventListener('DOMContentLoaded', function () {
    /** =============================================================
     * Variables
     ============================================================== */
    let mapElement = document.getElementById("map");
    if (mapElement) {

        //Affichage de la consigne
        getConsigne();

        let noMapElement = document.getElementById('noMap');

        // Créer une nouvelle carte centrée sur la France
        const map = new google.maps.Map(document.getElementById('map'), {
            center: {
                lat: 46.84779206569178,
                lng: 2.661127156250016
            },
            zoom: 6, // Niveau de zoom pour avoir la France en totalité
        });

        // Création de la variable Infobulle
        const infowindow = new google.maps.InfoWindow();

        // Evenement du clic sur la carte pour faire disparaitre l'infobulle
        google.maps.event.addListener(map, 'click', function () {
            infowindow.close();
        })

        // Ensemble des markers pour la carte
        map.markers = [];

        // Autocomplete (on le met en place pour éviter un maximum des failed adresses
        let pepiteSearch = document.getElementById('pepites-search');
        const options = {};

        let suggestionsContainer = document.createElement('div');
        suggestionsContainer.setAttribute('id', 'suggestions-container');
        pepiteSearch.parentNode.appendChild(suggestionsContainer);


        document.querySelectorAll('input[name="etudiant_status"]').forEach(function(radioButton) {
            radioButton.addEventListener('change', function () {
                suggestionsContainer.innerHTML = '';
            });
        });

        let autocomplete = null;

        // Ajoutez un écouteur d'événements pour détecter les modifications de saisie dans l'élément de recherche
        pepiteSearch.addEventListener('input', function() {
            let category = getCategory();

            if (category === 'etudiant') {
                initStudentSearchSuggestions(); // Appel de la fonction d'initialisation des suggestions pour les étudiants
            }
        });


        // Ecouteur d'evenement pour la saisie dans le champ de recherche
        let searchButton = document.getElementById('searchButton');
        if (searchButton) {
            searchButton.addEventListener('click', function () {
                clearAffichage();

                // On récupère le contenu de la recherche
                let searchInput = document.getElementById('pepites-search').value.toLowerCase();
                let category = getCategory();

                // CAS 1 : Je ne suis pas étudiant
                if (category === 'non_etudiant'){
                    //je suis renvoyé vers le Pépite le plus proche de chez moi
                    findNearestAntenne(searchInput);
                }
                else {
                    // CAS 2 : je suis étudiant en IDF
                    getRegionByInputLocation(searchInput, function (regionUtilisateur) {

                        if (regionUtilisateur === "IDF") {
                            //j'ai le choix parmi les 8 Pépites d'Île de France (si mon établissement n'est pas référencé)
                            searchIDF(searchInput);

                        } else {
                            // CAS 3 : Je suis étudiant hors Île de France
                            //je suis renvoyé vers le Pépite en fonction de mon département
                            searchPepiteByDept(searchInput);
                        }
                    });
                }
                noMapElement.classList.remove('visible');
                mapElement.classList.add('visible');
            });
        }


        // Fonction pour créer un marqueur et l'ajouter à la carte
        function createMarkerAntenne(antenne) {
            let contentString = getAntenneInfoContent(antenne);

            // Création du marker de l'antenne
            let lat = parseFloat(antenne.dataset.lat);
            let lng = parseFloat(antenne.dataset.lng);

            let icon = getIconPin();
            let iconSize = new google.maps.Size(32, 48);

            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: {
                    url: icon, // URL de l'icone
                    size: iconSize, // Taille de l'icone
                    scaledSize: iconSize, // Taille de l'icone
                    origin: new google.maps.Point(0, 0), // Point d'origine de l'icone
                    anchor: new google.maps.Point(iconSize.width / 2, iconSize.height) // Point d'ancrage de l'icone
                }
            });
            map.markers.push(marker);

            // Evenement au clic sur le marker pour ouvrir l'infobulle
            google.maps.event.addListener(marker, 'click', function () {
                infowindow.setContent(contentString);
                infowindow.open({
                    anchor: marker,
                    map
                });
            });
        }

        // Fonction pour afficher une antenne avec un marqueur
        function displayAntenne(antenne) {
            antenne.classList.add('visible');
            // Afficher la fiche pépite contenant l'antenne
            let parentPepite = antenne.closest('.pepite');
            if (parentPepite) {
                parentPepite.classList.add('visible');
            }
            // Créer une instance de google.maps.Marker pour l'antenne
            createMarkerAntenne(antenne);
        }

        //Fonction pour afficher la consigne adéquate
        function getConsigne(){
            let radioButtons = document.querySelectorAll('input[name="etudiant_status"]');

            // Attachez un gestionnaire d'évènements à chaque bouton radio
            radioButtons.forEach(function(radioButton) {
                radioButton.addEventListener('change', function() {
                    // Cachez toutes les consignes
                    document.querySelectorAll('.etudiant-consigne, .non-etudiant-consigne').forEach(function(consigne) {
                        consigne.style.display = 'none';
                    });

                    // Affichez la consigne correspondante au bouton radio sÃ©lectionnÃ©
                    let consigneClass = radioButton.value === 'etudiant' ? 'etudiant-consigne' : 'non-etudiant-consigne';
                    document.querySelector('.' + consigneClass).style.display = 'block';
                });
            });
        }

        // Fonction pour obtenir le contenu de l'infobulle de l'antenne
        function getAntenneInfoContent(antenne) {
            return '<div class="info-window">' +
                '<div class="antenne-title">' + antenne.dataset.title + '</div>' +
                '<div class="antenne-pepite">Rattaché à  <br>' + antenne.closest('.pepite').querySelector('.pepite-title').dataset.title + '</div>' +
                '</div>';
        }

        // Associer le bon pin en fonction de la catégorie
        function getIconPin() {
            let icon = gmap.iconEtudiant;
            // if (categorie === "etudiant") {
            //     icon = gmap.iconEtudiantTrue;
            // // } else {
            // //     icon = gmap.iconEtudiantFalse;
            // }
            return icon;
        }

        // Fonction pour appeler toutes les fonctions de nettoyage
        function clearAffichage(){
            let noResultsMessage = document.getElementById('noResultsMessage');
            noResultsMessage.style.display = 'none';
            let suggestionsContainer = document.getElementById('suggestions-container');
            suggestionsContainer.innerHTML = '';
            // On clear la map et l'affichage des fiches pÃ©pites et leurs antennes
            clearAntennes();
            clearPepites();
            clearMarkers();
        }

        // Fonction pour effacer tous les markers de la carte
        function clearMarkers() {
            // Parcourir tous les markers existants
            map.markers.forEach(function (marker) {
                // Supprimer le marker de la carte
                marker.setMap(null);
            });
            // Vider le tableau des markers
            map.markers = [];
        }

        // Fonction pour enlever l'affichage des Fiches PÃ©pites
        function clearPepites() {
            let allPepites = document.querySelectorAll('.pepite');
            allPepites.forEach(pepite => pepite.classList.remove('visible'));
        }

        // Fonction pour enlever l'affichage des Antennes
        function clearAntennes() {
            let allAntennes = document.querySelectorAll('.antenne');
            Array.from(allAntennes).every((antenne) => antenne.classList.remove('visible'));
        }

        // Fonction pour récupérer la catégorie (Etudiant ou non)
        function getCategory() {
            let selectedCategory = document.querySelector('input[name="etudiant_status"]:checked');
            return selectedCategory.value;
        }

        // Fonction pour centrer la carte sur le marker visible
        function centerVisibleMarkers(markers) {
            // Filtrer les marqueurs avec des coordonnées valides
            let validMarkers = markers.filter(marker => !isNaN(marker.getPosition().lat()) && !isNaN(marker.getPosition().lng()));

            // Vérifier s'il y a des marqueurs avec des coordonnées valides
            if (validMarkers.length > 0) {
                // Créer une limite pour les marqueurs visibles
                let bounds = new google.maps.LatLngBounds();

                validMarkers.forEach(marker => {
                    bounds.extend(marker.getPosition());
                });

                // Adapter la vue de la carte pour inclure tous les marqueurs visibles
                map.fitBounds(bounds);

                // Attendre que fitBounds soit complètement effectué
                google.maps.event.addListenerOnce(map, 'idle', function () {
                    // Limiter le niveau de zoom pour éviter un zoom excessif
                    let maxZoom = 15; // Définissez la valeur maximale de zoom souhaitée
                    if (map.getZoom() > maxZoom) {
                        map.setZoom(maxZoom);
                    }
                });
            }
        }

        ///////////////// ///////////////// /////////////////
        // CAS 1 : je ne suis pas/plus étudiant
        ///////////////// ///////////////// /////////////////

        // Fonction pour trouver l'antenne la plus proche
        function findNearestAntenne(userAddress) {
            // Variables si pas de résultats
            let noResultsMessage = document.getElementById('noResultsMessage');
            let resultsFound = false;

            // Utiliser la Geocoding API pour obtenir les coordonnées de l'adresse de l'utilisateur
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: userAddress }, function (results, status) {
                if (status === 'OK' && results.length > 0) {
                    let userLocation = results[0].geometry.location;

                    // Calculer la distance entre chaque antenne et l'emplacement de l'utilisateur
                    let allAntennes = document.querySelectorAll('.antenne');
                    let nearestAntenna = null;
                    let nearestDistance = Number.MAX_VALUE;

                    allAntennes.forEach(function (antenne) {
                        let antenneLocation = new google.maps.LatLng(parseFloat(antenne.dataset.lat), parseFloat(antenne.dataset.lng));
                        let distance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, antenneLocation);

                        if (distance < nearestDistance) {
                            nearestAntenna = antenne;
                            nearestDistance = distance;
                        }
                    });

                    // Afficher la plus proche antenne
                    if (nearestAntenna) {
                        // Afficher la fiche pépite contenant la plus proche antenne
                        nearestAntenna.classList.add('visible');
                        nearestAntenna.closest('.pepite').classList.add('visible');
                        resultsFound = true;

                        //Création du marker
                        createMarkerAntenne(nearestAntenna);
                        centerVisibleMarkers(map.markers)
                    }
                }

                // Afficher ou masquer le message en fonction des résultats de la recherche
                if (resultsFound) {
                    noResultsMessage.style.display = 'none';
                } else {
                    noResultsMessage.style.display = 'block';
                }
            });
        }

        ///////////////// ///////////////// /////////////////
        // CAS 2 et 3 : je suis étudiant
        ///////////////// ///////////////// /////////////////

        function initStudentSearchSuggestions() {
            let suggestionsContainer = document.getElementById('suggestions-container');
            // Effacez le contenu du conteneur de suggestions
            suggestionsContainer.innerHTML = '';

            // Récupérez la valeur saisie dans le champ de recherche
            let inputValue = pepiteSearch.value.toLowerCase();

            // Vérifiez si la longueur de la saisie est suffisante
            if (inputValue.length > 2) {
                // Filtrez les suggestions en fonction de la valeur saisie
                let suggestions = filterNoms(inputValue);

                // Affichez les suggestions dans le conteneur
                if (suggestions.length > 0) {
                    suggestions.forEach(function(address) {
                        let suggestionElement = document.createElement('div');
                        suggestionElement.textContent = address;
                        suggestionElement.addEventListener('click', function() {
                            pepiteSearch.value = address;
                            suggestionsContainer.innerHTML = '';
                        });
                        suggestionsContainer.appendChild(suggestionElement);
                    });
                } else {
                    suggestionsContainer.innerHTML = '<div>Aucune suggestion</div>';
                }
            }
        }

        // Fonction pour filtrer les noms en fonction de la valeur saisie dans le champ de recherche
        function filterNoms(input) {
            let inputValue = input.toLowerCase();
            return encodedAddresses.filter(function (nom) {
                return nom.toLowerCase().includes(inputValue);
            });
        }

        ///////////////// ///////////////// /////////////////
        // CAS 2 : je suis étudiant en Ile de France
        ///////////////// ///////////////// /////////////////

        // Fonction pour récupérer la région tapée dans la barre de recherche
        function getRegionByInputLocation(searchInput, callback) {
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: searchInput, componentRestrictions: { country: "fr"  } }, function (results, status) {
                if (status === 'OK' && results.length > 0) {
                    // Récupérer la région à partir de l'adresse tapée
                    let addressComponents = results[0].address_components;
                    // Chercher le département parmi les address_components
                    for (let i = 0; i < addressComponents.length; i++) {
                        let component = addressComponents[i];
                        if (component.types.includes('administrative_area_level_1')) {
                            callback(component.short_name);
                            return;
                        }
                    }
                }
                callback(null); // Appeler le callback avec null en cas d'erreur ou de non-trouvaille
            });
        }

        // Fonction pour récupérer la région des antennes
        function getRegionAntenne(location , callback) {
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: location }, function (results, status) {
                if (status === 'OK' && results.length > 0) {
                    for (let i = 0; i < results[0].address_components.length; i++) {
                        let addressComponent = results[0].address_components[i];
                        if (addressComponent.types.includes('administrative_area_level_1')) {
                            // 'administrative_area_level_1' est le type pour la région en France
                            callback(addressComponent.short_name);
                            return; // Assurez-vous de quitter la fonction après avoir appelé le callback
                        }
                    }
                }
                callback(null); // Appeler le callback avec null en cas d'erreur ou de non-trouvaille
            });
        }

        // Fonction pour chercher les antennes/pépites d'Île de France
        function searchIDF(searchInput) {
            // Variables si pas de résultats
            let noResultsMessage = document.getElementById('noResultsMessage');
            let resultsFound = false;

            let allAntennes = document.querySelectorAll('.antenne');
            let allAntennesArray = Array.from(allAntennes);
            // On vérifie d'abord si le nom ou l'adresse de l'antenne correspond à l'input de la barre de recherche
            allAntennesArray.find(function (antenne) {
                let textContent = antenne.textContent.toLowerCase();
                let antenneAdresse = antenne.dataset.address.toLowerCase();
                let antenneCP = antenne.dataset.cp;

                // Si la recherche amène des résultats par rapport à l'adresse, au contenu de l'antenne, on affiche l'Antenne et son Pépite
                if ((textContent.includes(searchInput.toLowerCase()))|| (antenneAdresse.includes(searchInput.toLowerCase())) || (antenneCP.includes(searchInput)) ) {
                    displayAntenne(antenne);
                    centerVisibleMarkers(map.markers);
                    resultsFound = true;
                }
                if(resultsFound) {
                    return true;
                }
            });

            if (resultsFound) {
                noResultsMessage.style.display = 'none';
            }
            else {
                // Sinon on affiche les Pépites d'Île de France
                allAntennes.forEach(function (antenne) {
                    let antenneLocation = new google.maps.LatLng(parseFloat(antenne.dataset.lat), parseFloat(antenne.dataset.lng));
                    // Utilisation de la fonction getRegionAntenne
                    getRegionAntenne(antenneLocation, function (antenneRegion) {
                        if (antenneRegion === "IDF") {
                            if (antenne.classList.contains('main')) {
                                antenne.classList.add('visible');
                                antenne.closest('.pepite').classList.add('visible');

                                //Création du marker
                                createMarkerAntenne(antenne);
                                centerVisibleMarkers(map.markers)
                                noResultsMessage.style.display = 'none';
                            }
                        }
                    });
                });
            }
        }


        ///////////////// ///////////////// /////////////////
        // CAS 3 : je suis étudiant hors Ile de France
        ///////////////// ///////////////// /////////////////


        function getDeptByInputLocation(searchInput, callback) {
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: searchInput }, function (results, status) {
                if (status === 'OK' && results.length > 0) {
                    // Récupérer la région à partir de l'adresse tapée
                    let addressComponents = results[0].address_components;

                    // Chercher le département parmi les address_components
                    for (let i = 0; i < addressComponents.length; i++) {
                        let component = addressComponents[i];
                        if (component.types.includes('administrative_area_level_2')) {
                            callback(removeAccents(component.short_name.toLowerCase()));
                            return;
                        }
                    }
                }
                callback(null); // Appeler le callback avec null en cas d'erreur ou de non-trouvaille
            });
        }

        // Fonction pour chercher le Pépite rattaché au département de l'utilisateur
        function searchPepiteByDept(searchInput){
            let noResultsMessage = document.getElementById('noResultsMessage');
            let resultsFound = false;

            let allDepartements = document.querySelectorAll('.departement');
            allDepartements.forEach(function (departement) {
                let departementPepite = departement.dataset.dept;


                // CAS SPECIFIQUE : Je suis étdiant dans les DOM TOM ET COM
                getCountryByInputLocation(searchInput, function (countryUtilisateur) {
                    if (countryUtilisateur === departementPepite) {
                        let pepite = departement.closest('.pepite');
                        if (pepite) {
                            let antennes = pepite.querySelectorAll('.antenne');
                            pepite.classList.add('visible');
                            resultsFound = true;
                            for (let i = 0; i < antennes.length; i++) {
                                antennes[i].classList.add('visible');
                                //Création du marker
                                createMarkerAntenne(antennes[i]);
                            }
                            centerVisibleMarkers(map.markers);

                            if (resultsFound) {
                                noResultsMessage.style.display = 'none';
                            } else {
                                noResultsMessage.style.display = 'block';
                            }
                        }
                    } else {
                        //Recherche par départements rattachés
                        // getDeptByInputLocation(searchInput, function (deptUtilisateur) {
                        //
                        //     if (deptUtilisateur === departementPepite) {
                        //         let pepite = departement.closest('.pepite');
                        //         if (pepite) {
                        //             let antennes = pepite.querySelectorAll('.antenne');
                        //             pepite.classList.add('visible');
                        //             resultsFound = true;
                        //             for (let i = 0; i < antennes.length; i++) {
                        //                 antennes[i].classList.add('visible');
                        //                 //Création du marker
                        //                 createMarkerAntenne(antennes[i]);
                        //             }
                        //             centerVisibleMarkers(map.markers);
                        //         }
                        //     }
                        //     else {
                                let antennes = document.querySelectorAll('.antenne');
                                // Parcourez chaque antenne de la pépite
                                antennes.forEach(function(antenne) {
                                    // Vérifiez si le titre de cette antenne correspond à la valeur de Searchinput
                                    if (antenne.getAttribute('data-title').toLowerCase() === searchInput) {

                                        let pepite = antenne.closest('.pepite');
                                        if (pepite) {
                                            let antennes = pepite.querySelectorAll('.antenne');
                                            pepite.classList.add('visible');
                                            resultsFound = true;
                                            for (let i = 0; i < antennes.length; i++) {
                                                antennes[i].classList.add('visible');
                                                //Création du marker
                                                createMarkerAntenne(antennes[i]);
                                            }
                                            centerVisibleMarkers(map.markers);
                                        }
                                    }
                                });

                            // }
                            // if (resultsFound) {
                            //     noResultsMessage.style.display = 'none';
                            // } else {
                            //     noResultsMessage.style.display = 'block';
                            // }
                        // });
                    }
                });
            });
        }


        ///////////////// ///////////////// /////////////////
        // CAS SPECIFIQUE : je suis étudiant dans les COM et DOMTOM
        ///////////////// ///////////////// /////////////////
        function getCountryByInputLocation(searchInput, callback) {
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: searchInput }, function (results, status) {
                if (status === 'OK' && results.length > 0) {
                    // Récupérer la région à partir de l'adresse tapée
                    let addressComponents = results[0].address_components;

                    // Chercher le département parmi les address_components
                    for (let i = 0; i < addressComponents.length; i++) {
                        let component = addressComponents[i];
                        if (component.types.includes('country')) {
                            callback(component.short_name.toLowerCase());
                            return;
                        }
                    }
                }
                callback(null); // Appeler le callback avec null en cas d'erreur ou de non-trouvaille
            });
        }



        function removeAccents(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        }

    }
});